/**
 * LM Labels and Badges - Vanilla JS
 * Compatible con tema Horizon (Motovibradores)
 */
(function () {
  'use strict';

  function parseJSON(str) {
    if (!str) return null;
    try { return JSON.parse(str); } catch (e) {
      console.warn('[LM Badges] JSON parse error:', e.message);
      return null;
    }
  }

  function getAllBadgeConfigs() {
    var els = document.getElementsByClassName('lm-badges-block-data');
    var configs = [];
    for (var i = 0; i < els.length; i++) {
      var cfg = parseJSON(els[i].getAttribute('lm-badges-block-data'));
      if (cfg) configs.push(cfg);
    }
    return configs;
  }

  function canShow(label, productData) {
    if (!label.settings.show_on_product_card) return false;
    if (label.type === 'sale-label') return productData.compare_at_price > productData.price;
    if (label.type === 'sold-out-label') return !productData.available;

    if (label.settings.schedule_enabled) {
      var tz = label.settings.timezone || 0;
      function toMs(y, m, d, h, min) {
        var dt = new Date(y, m - 1, d, h, min);
        return dt.getTime() + (-1 * tz * 60 - dt.getTimezoneOffset()) * 60000;
      }
      var now = Date.now();
      var end   = toMs(label.settings.end_year,   label.settings.end_month,   label.settings.end_day,   label.settings.end_hour,   label.settings.end_minute);
      var start = toMs(label.settings.start_year, label.settings.start_month, label.settings.start_day, label.settings.start_hour, label.settings.start_minute);
      if (now > end || now < start) return false;
    }

    var hasProductFilter    = label.settings.applied_products    && label.settings.applied_products.length > 0;
    var hasCollectionFilter = label.settings.applied_collections && label.settings.applied_collections.length > 0;

    if (!hasProductFilter && !hasCollectionFilter) return true;

    if (hasProductFilter && label.settings.applied_products.indexOf(productData.product_id) !== -1) return true;

    if (hasCollectionFilter && productData.collections) {
      for (var i = 0; i < label.settings.applied_collections.length; i++) {
        if (productData.collections.indexOf('||' + String(label.settings.applied_collections[i]) + '||') !== -1) return true;
      }
    }

    return false;
  }

  function buildBadgeHTML(label, productData) {
    if (!canShow(label, productData)) return null;

    var opacity    = (label.settings.opacity || 100) / 100;
    var shapeStyle = '';
    if (label.settings.type === 'round')        shapeStyle = 'border-radius:6px;';
    if (label.settings.type === 'rounded-full') shapeStyle = 'border-radius:999px;';

    if (label.settings.image && label.settings.image.src) {
      var size       = label.settings.size        || 5;
      var sizeMob    = label.settings.size_mobile || 4;
      var imgW       = size    * 15;
      var imgWMob    = sizeMob * 15;
      var aspect     = label.settings.image_aspect_ratio || 1;
      var imgSrc     = label.settings.image.src + '&width=' + (imgW * 2);
      var alt        = label.settings.image_alt || productData.title || '';

      return '<div class="lm-badge-container lm-badge-' + label.id + '" style="opacity:' + opacity + ';pointer-events:none;">'
        + '<style>.lm-badge-' + label.id + ' img{width:' + imgWMob + 'px}@media(min-width:768px){.lm-badge-' + label.id + ' img{width:' + imgW + 'px}}</style>'
        + '<img loading="lazy" alt="' + alt + '" src="' + imgSrc + '" style="height:auto;display:block;">'
        + '</div>';
    }

    if (label.settings.content) {
      var text = label.settings.content;
      if (label.type === 'sale-label') {
        var pct = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
        text = text.replace(/{sale}/gi, pct > 0 ? pct + '%' : '');
      }
      var bg  = label.settings.background_color || '#333';
      var col = label.settings.text_color        || '#fff';
      return '<div class="lm-badge-container lm-badge-' + label.id + '" style="opacity:' + opacity + ';pointer-events:none;">'
        + '<span style="background:' + bg + ';color:' + col + ';padding:3px 8px;font-size:0.72rem;font-weight:700;display:inline-block;line-height:1.4;' + shapeStyle + '">' + text + '</span>'
        + '</div>';
    }

    return null;
  }

  function getOrCreatePositionContainer(el, position) {
    var cls = 'lm-pos-' + position;
    var c = el.querySelector('.' + cls);
    if (!c) {
      c = document.createElement('div');
      var s = 'position:absolute;display:flex;flex-direction:column;gap:4px;z-index:10;pointer-events:none;';
      if (position.indexOf('top')    !== -1) s += 'top:8px;';
      if (position.indexOf('bottom') !== -1) s += 'bottom:8px;';
      if (position.indexOf('left')   !== -1) s += 'left:8px;align-items:flex-start;';
      if (position.indexOf('right')  !== -1) s += 'right:8px;align-items:flex-end;';
      c.className = cls;
      c.setAttribute('style', s);
      el.appendChild(c);
    }
    return c;
  }

  function initCard(cardGallery) {
    if (cardGallery.dataset.lmDone) return;
    cardGallery.dataset.lmDone = '1';

    var productData = parseJSON(cardGallery.getAttribute('x-labels-data'));
    if (!productData) return;

    var configs = getAllBadgeConfigs();
    if (!configs.length) return;

    var hasBadge = configs.some(function(label) {
      return label.enable && canShow(label, productData);
    });

    if (!hasBadge) return;

    // card-gallery has overflow:hidden — override it so absolute badges are visible
    cardGallery.style.overflow = 'visible';
    // Also ensure position relative (theme sets it, but just in case)
    if (window.getComputedStyle(cardGallery).position === 'static') {
      cardGallery.style.position = 'relative';
    }

    configs.forEach(function(label) {
      if (!label.enable) return;
      var html = buildBadgeHTML(label, productData);
      if (!html) return;
      var container = getOrCreatePositionContainer(cardGallery, label.settings.position || 'top-left');
      container.insertAdjacentHTML('beforeend', html);
    });
  }

  function observeCards() {
    var cards = document.querySelectorAll('[x-labels-data]');
    if (!cards.length) return;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { initCard(e.target); obs.unobserve(e.target); }
        });
      }, { rootMargin: '300px' });
      cards.forEach(function(c) { obs.observe(c); });
    } else {
      cards.forEach(initCard);
    }
  }

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('[x-labels-data]').forEach(function(el) {
      delete el.dataset.lmDone;
      el.querySelectorAll('.lm-badge-container, [class^="lm-pos-"]').forEach(function(b) { b.remove(); });
      el.style.overflow = '';
    });
    observeCards();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCards);
  } else {
    observeCards();
  }

})();
